import React from 'react';
import { useState } from 'react';
import EmptyCheckbox from '../../assets/img/empty.svg';
import FiledCheckbox from '../../assets/img/filed.svg';
import { useEffect } from 'react';

export default function RoundCheckButton({ active }) {
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    if (active) {
      setChecked(true);
    }
  }, []);

  return (
    <>
      {checked ? (
        <img
          role="checkbox"
          onClick={() => {
            setChecked(!checked);
          }}
          tabIndex={0}
          onKeyPress={() => setChecked(!checked)}
          className="user-image"
          src={FiledCheckbox}
          alt="checkbox"
        />
      ) : (
        <img
          role="checkbox"
          onClick={() => {
            setChecked(!checked);
          }}
          tabIndex={0}
          onKeyPress={() => setChecked(!checked)}
          className="user-image"
          src={EmptyCheckbox}
          alt="checkbox"
        />
      )}
    </>
  );
}
